export default {
      id: "profile-plus-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#profile-plus",
      toString: function () {
        return this.url;
      }
    }